import { ApiProperty } from '@nestjs/swagger';
import { LiquidacionVdPdfPage1Dto } from './liquidacion-vd-pdf.dto';
import { LiquidacionVdPdfPage2Dto } from './liquidacion-vd-pdf.page2.dto';
import { LiquidacionVdPdfPageTraficoDto } from './liquidacion-vd-pdf.page-trafico.dto';
import { LiquidacionVdPdfPage3Dto } from './liquidacion-vd-pdf.page3.dto';
import { LiquidacionVdPdfPage4Dto } from './liquidacion-vd-pdf.page4.dto';

/**
 * Datos estructurados por páginas y secciones para renderizar el PDF VD.
 * Hoja 1: Información general, Resumen operación, Participación.
 */
export class LiquidacionVdPdfDataDto {
  @ApiProperty({ type: LiquidacionVdPdfPage1Dto })
  page1!: LiquidacionVdPdfPage1Dto;

  // Futuras hojas (detalles por contenedor, descuentos, navegación, etc.)
  @ApiProperty({ type: LiquidacionVdPdfPage2Dto, required: false })
  page2?: LiquidacionVdPdfPage2Dto;

  @ApiProperty({ type: LiquidacionVdPdfPageTraficoDto, required: false })
  pageTrafico?: LiquidacionVdPdfPageTraficoDto;

  @ApiProperty({ type: LiquidacionVdPdfPage3Dto, required: false })
  page3?: LiquidacionVdPdfPage3Dto;

  @ApiProperty({ type: LiquidacionVdPdfPage4Dto, required: false })
  page4?: LiquidacionVdPdfPage4Dto;
}
